export class Dropdown {
    container;

    constructor(containerHTML) {
        this.container = containerHTML;
        this.container.addEventListener("click", this.toggleMenu.bind(this));
        window.addEventListener("click", this.closeMenuOnClick.bind(this));
    }

    toggleMenu() {
        const dropdownMenu = this.container.querySelector(".dropdown__menu");
        dropdownMenu.classList.toggle("show");
    }

    closeMenuOnClick(event) {
        if (!event.target.matches(".dropdown__trigger")) {
            let dropdowns = document.getElementsByClassName("dropdown__menu");
            let i;
            for (i = 0; i < dropdowns.length; i++) {
                let openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) {
                    openDropdown.classList.remove("show");
                }
            }
        }
    }
}
